import React from 'react';
import { connect } from 'react-redux';

//Components
import SmartMenu from '../index';
import { DataSourceSlugs } from 'Shared/constants/types';
import { SmartLinkLogo } from '../../components';
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpAvatar from 'Wpds/components/avatar/WpAvatar';
import { WpButton } from 'Wpds/components/button';

//Selectors
import { getFigmaSignUpUrl } from 'Shared/selectors/smartLinks';

//Logos
import FigmaLogo from 'Shared/images/figma-logo.svg';

//Styles
import '../SmartMenu.scss';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

//Helpers
import { trackClickedConnectApp } from 'Shared/tracking/tracking';

const FigmaSmartMenu = props => {
  const { tr } = useTranslation();
  const { hasFigmaIntegration, figmaSignUpUrl } = props;

  const renderSmartLinkDetail = smartLinkDetail => {
    const { created_by, created_by_avatar, created_time, last_modified_time } = smartLinkDetail;
    const created_by_initials = created_by
      ? created_by.includes(' ')
        ? created_by.substr(0, 1) + created_by.split(' ')[1].substr(0, 1)
        : created_by.substr(0, 1)
      : '';
    const created_by_display_avatar = created_by_avatar
      ? created_by_avatar
      : { initials: created_by_initials, color: '#57CA8C' };
    const className = 'SmartMenu__content__row';

    return (
      <>
        <div className={className}>
          <div className={`${className}__label`}>{tr('perform.smart_links.figma.created_by_label')}</div>
          <div className={`${className}__value`}>
            {created_by && <WpAvatar size="sm" avatar={created_by_display_avatar} />}
            {!created_by && (
              <span className={`${className}__empty-user-icon`}>
                <WpIcon name="user" size="md" />
              </span>
            )}
            <div className={`${className}__value__text`}>{created_by || tr('perform.smart_links.common.unknown')}</div>
          </div>
        </div>
        <p />
        <div>{tr('perform.smart_links.figma.created_on', created_time)}</div>
        <div>{tr('perform.smart_links.figma.last_modified_on', last_modified_time)}</div>
        <p />
        <a href={smartLinkDetail.url} target="blank" rel="noopener norefferer">
          {tr('perform.smart_links.figma.view_file')}
        </a>
      </>
    );
  };

  const handleConnectClick = () => {
    trackClickedConnectApp(DataSourceSlugs.figma);
    window.location.href = figmaSignUpUrl;
  };

  const renderEmbedingContent = () => {
    const className = 'SmartMenu__content__button';
    return (
      <>
        <div className={className}>{tr('perform.smart_links.figma.connect_prompt')}</div>
        <p />
        <div className={className}>
          <WpButton variant="tertiary" onClick={handleConnectClick} block>
            {tr('perform.smart_links.figma.connect_cta')}
          </WpButton>
        </div>
      </>
    );
  };

  const menuTitle = () => (
    <>
      <SmartLinkLogo src={FigmaLogo} />
    </>
  );

  return (
    <SmartMenu
      hasDocumentIntegration={hasFigmaIntegration}
      renderEmbedingContent={renderEmbedingContent}
      renderSmartLinkDetail={renderSmartLinkDetail}
      objectName={tr('perform.smart_links.figma.object_name')}
      menuTitle={menuTitle}
      {...props}
    />
  );
};

const mapStateToProps = state => ({
  hasFigmaIntegration: state.data_sources?.find(({ slug }) => slug === DataSourceSlugs.figma)?.connected,
  figmaSignUpUrl: getFigmaSignUpUrl(state),
});

export default connect(mapStateToProps)(FigmaSmartMenu);
